import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimes, faBars, faExclamationTriangle } from '@fortawesome/free-solid-svg-icons';

import CharacterLookup from '../autocomplete/CharacterLookup';
import LoginButton from './LoginButton';
import Toast from '../components/Toast';
import Ad from './Ad';

import logo from '../images/logo.png';

export default class Header extends Component {
    constructor(props) {
        super(props);
        this.state = {
            showSearch: false
        };
    }

    componentDidMount() {
        this.action(this.props.history.location);
        this.unlisten = this.props.history.listen((location, action) => {
            this.action(location);
        });
    }

    componentWillUnmount() {
        this.unlisten();
    }

    action(location) {
        this.setState({ showSearch: false });
    }

    toggleSearch = () => {
        this.setState({ 'showSearch': !this.state.showSearch });
    }

    render() {
        return (
            <>
                <div className="d-flex header bar">
                    {this.state.showSearch && !window.bootstrap.md.matches ? null : <Link to="/"><img src={logo} alt="Data for Azeroth Logo" width="250" height="50" /></Link>}
                    {!this.state.showSearch && !window.bootstrap.md.matches ? null :
                        <>
                            <div className={'my-auto ' + (window.bootstrap.md.matches ? 'ml-auto mr-1' : 'ml-1 flex-fill')}>
                                <CharacterLookup showCompare={this.state.showCompare} history={this.props.history} />
                            </div>
                            <div className={'my-auto ' + (window.bootstrap.md.matches ? 'mr-1' : 'ml-1')}>
                                <LoginButton history={this.props.history} />
                            </div>
                        </>
                    }
                    {window.bootstrap.md.matches ? null : (
                        this.state.showSearch ?
                        <div className="my-auto m-1">
                            <button type="button" className="btn btn-primary" onClick={this.toggleSearch}><FontAwesomeIcon icon={faTimes} /></button>
                        </div>
                        :
                        <div className="my-auto m-1 ml-auto">
                            <button type="button" className="btn btn-primary" onClick={this.toggleSearch}><FontAwesomeIcon icon={faBars} /></button>
                        </div>
                    )}
                </div>
                <Toast show={false}>
                    <FontAwesomeIcon icon={faExclamationTriangle} /> Aug 26 &mdash; Sep 26: Support a streamer (make sure they are live!) to get a Watcher of the Huntress pet! <Link to="/twitch-drops">Click here for details</Link>
                </Toast>
                <Ad slot="header" />
            </>
        );
    }
}